import { styled } from '@linaria/react'
import { MinimalCard, MinimalSkipLink } from '@ovasabi/ui-minimal'
import { minimalVars as v } from '@ovasabi/ui-minimal/tokens'
import { LandingStyle } from './LandingStyle'
import { PublicFooter, PublicNav } from './PublicLayout'

const Style = {
  ...LandingStyle,
  Main: styled.main`
    max-width: 1000px;
    margin: auto;
    padding: ${v.space.md};
    display: grid;
    gap: ${v.space.sm};
    h1, h2, p { margin: 0; }
  `,
  Actions: styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: ${v.space.xs};
    margin-top: ${v.space.sm};
  `,
}

export const PublicPlansPage = () => (
  <Style.Page>
    <MinimalSkipLink />
    <PublicNav />
    <Style.Main id="main-content" tabIndex={-1}>
      <h1>Plan your meals for the week.</h1>
      <p>Choose dishes from local kitchens for yourself or your household.</p>
      <MinimalCard padding="sm">
        <h2>Plan freely. Pay when you order.</h2>
        <p>Save meals to your calendar, then add a day or week to your cart. Food and service fees are shown before payment.</p>
        <p>Collect your meals from the kitchen address shown at checkout.</p>
        <Style.Actions>
          <Style.Cta to="/register?role=customer&returnTo=%2Fmealplan">Create account →</Style.Cta>
          <Style.Cta data-variant="ghost" to="/login?role=customer&returnTo=%2Fmealplan">Sign in</Style.Cta>
        </Style.Actions>
      </MinimalCard>
      <MinimalCard padding="sm">
        <h2>Build a week that suits you.</h2>
        <p>Browse dishes, choose dates and portions, and review your saved meals before checkout.</p>
      </MinimalCard>
    </Style.Main>
    <PublicFooter />
  </Style.Page>
)
